import { yupResolver } from '@hookform/resolvers/yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import FieldV2 from 'src/components/FormComponents/FieldV2'
import Form from 'src/components/FormComponents/Form'
import Submit from 'src/components/FormComponents/Submit'
import { selectProductTabFilters } from 'src/features/stock-management/StockManagementSeletor'
import { actions } from 'src/features/stock-management/StockManagementState'
import * as S from './Form.styles'
import { schema } from './Schema'
import { MovementsTabFormValue } from './types'

export default () => {
  const currentDate = new Date()
  const startDate = new Date()
  startDate.setDate(startDate.getDate() - 30)

  const {
    control,
    handleSubmit,
  } = useForm<MovementsTabFormValue>({
    resolver: yupResolver(schema),
    defaultValues: {
      startDate,
      endDate: currentDate,
    },
  })
  const dispatch = useDispatch()
  const productTabFilters = useSelector(selectProductTabFilters)

  const onSubmit: SubmitHandler<MovementsTabFormValue> = (data) => {
    dispatch(actions.clearMovementsTab())
    dispatch(actions.setProductTabsFilters({ ...productTabFilters, ...data }))
    dispatch(actions.getProductMovements())
  }

  return (
    <S.Form as={Form} onSubmit={handleSubmit(onSubmit)}>
      <S.Field
        as={FieldV2}
        labelText='Data inicio:'
        name='startDate'
        control={control}
        type='date'
        testId='start-date-test-id'
      />
      <S.Field
        as={FieldV2}
        labelText='Data fim:'
        name='endDate'
        control={control}
        type='date'
        testId='end-date-test-id'
      />
      <S.Submit as={Submit} disabled={false} text='Buscar' testId='search-movements-button-test-id' />
    </S.Form>
  )
}
